module.exports = __webpack_public_path__ + "static/img/border2.dd1cadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/border2.png
// module id = XCHZ
// module chunks = 1